import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useFetch from "../../../../hooks/use-fetch";
import BadgeSection from "./BadgeSection";

const HoF = ({setActiveSection}) => {
    const {t: translate } = useTranslation();
    const {apiUrl} = window['appConfig']
    const {data:hofData, error: hofErrors, initFunc: fetchHofData} = useFetch();
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [errors, setErrors] = useState(null);
    const fetchOptions = {
        method: 'GET',
    };
    const userProfileArchives = localStorage.getItem('glup') ? JSON.parse(localStorage.getItem('glup')) : {};
    
    useEffect(() => {
        if( userProfileArchives && Object.prototype.hasOwnProperty.call(userProfileArchives, 'hof') ) {
            setData(userProfileArchives.hof);
            setIsLoading(false);
        } else {
            setIsLoading(true);
            fetchHofData({url:`${apiUrl}/progress/halloffame`, options: fetchOptions})
        }
    }, [])

    useEffect(() => {
        if( hofData ) {
            setData(hofData)
            setIsLoading(false);
            userProfileArchives.hof = hofData;
            localStorage.setItem('glup', JSON.stringify(userProfileArchives));
        }
    }, [hofData])

    useEffect(() => {
        if(hofErrors) {
            setErrors(hofErrors)
        }
    }, [hofErrors])

    if( isLoading ) {
        return <div className={`user-dashboard user-dashboard__inner`}>
            <div className="user-dashboard__header">
                <button className="user-dashboard__back" onClick={() => {setActiveSection('')}}><FontAwesomeIcon icon={faChevronLeft} size="1x" /> {translate('back')}</button>
                <h4 className="user-dashboard__title">{translate('my-hof')}</h4>
                <p>{translate('hof-blurb')}</p>
            </div>
            <p className="user-dashboard__loading"></p>
        </div>
    }

    if( errors ) {
        return (
            <div className={`user-dashboard user-dashboard__inner`}>
                <div className="user-dashboard__header">
                    <button className="user-dashboard__back" onClick={() => {setActiveSection('')}}><FontAwesomeIcon icon={faChevronLeft} size="1x" /> {translate('back')}</button>
                    <h4 className="user-dashboard__title">{translate('learnt-fragments')}</h4>
                    <div className="dashboard-section">
                        <h4 className="dashboard-section__title">{translate('error-has-occured')}</h4>
                        <div className="error-container">
                            <details  className="error-report" style={{ whiteSpace: 'pre-wrap' }}>{errors}</details>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={`user-dashboard user-dashboard__inner`}>
            <div className="user-dashboard__header">
                <button className="user-dashboard__back" onClick={() => {setActiveSection('')}}><FontAwesomeIcon icon={faChevronLeft} size="1x" /> {translate('back')}</button>
                <h4 className="user-dashboard__title">{translate('my-hof')}</h4>
                <p>{translate('hof-blurb')}</p>
            </div>
            <div className="hofs">
                {Object.keys(data).map((location, index) => {
                    let objectives = data[location]

                    if(Object.keys(objectives).length === 0 ) return null;
                    
                    return (
                        <div className="hof-section" key={index}>
                            <h4 className="hof-section__title">{location}</h4>
                            <BadgeSection objectives={objectives} />
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default HoF